import React from 'react';
import linkedIn from '../images/Linkedin-Icon.png';
import gitHub from '../images/github.png';

export default (props) => {
    return (
        <footer className="footer-cmp">
            <div className="logo">
                SK
      <span>.</span>
            </div>

            <div className="footer-desc">
               <p>This is a demo website as part of my portfolio </p> 
                Check my other projects and full portfolio on gitHub and linkedIn </div>

    <div className="socials">
      <div className="linkedin">
        <a href="https://www.linkedin.com/in/shaked-katsir-014a5b188/" target="_blank" rel="noopener noreferrer">
          <img src={linkedIn} alt="" />
        </a>
      </div>

      <div className="github">
        <a href="https://github.com/shakedkt" target="_blank" rel="noopener noreferrer">
        <img src={gitHub} alt="" />
        </a>
      </div>
    </div>
        </footer>
    )
}

